var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTabActive()),expression:"isTabActive()"}],staticClass:"p-tabview-panel",attrs:{"role":"tabpanel"}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8333daea","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/tabpanel/TabPanel.vue
// module id = 1046
// module chunks = 6